import { progressAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

import { ColorSchemeStruct } from '../types';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(progressAnatomy.keys);

const BaseStyle = definePartsStyle((props) => {
  const colorScheme = ColorSchemeStruct.parse(props.colorScheme);
  return {
    track: {
      borderRadius: '1rem',
    },
    filledTrack: {
      '&[role="progressbar"]': {
        background: mode(`${colorScheme}.500`, `${colorScheme}.200`)(props),
        borderRightRadius: '0rem',
      },
    },
  };
});

// Exports
export const Progress = defineMultiStyleConfig({
  baseStyle: BaseStyle,
});
